module.exports = __webpack_public_path__ + "img/Insurance-Administrators.33211770.png";